<template>
	<div class="ticketBox">
		<div class="column">
			<el-radio :disabled="disabled" size="medium" @click="handlerSelectClick(1)" v-model="datas.cancelType"
				:label="1">&nbsp;</el-radio>
			<div style="flex: 1;text-align: center;" class="columnText3">不可取消</div>
		</div>
		<div class="column">
			<el-radio :disabled="disabled" @click="handlerSelectClick(5)" v-model="datas.cancelType"
				:label="5">&nbsp;</el-radio>
			<div style="flex: 1;text-align: center;" class="columnText3">随时退</div>
		</div>
		<div class="column">
			<el-radio :disabled="disabled" v-model="datas.cancelType" @click="handlerSelectClick(2)"
				:value="datas.cancelType == 2" :label="2">&nbsp;</el-radio>
			<div style="width: 274rpx;display: flex;align-items: center;justify-content: space-between;">
				<div class="columnText2">
					入住当天
				</div>
			</div>
			<div class="columnText3" style="margin: 0 0.2rem;width: 1rem;">{{ datas.cancelTime ? datas.cancelTime : '请选择' }}
			</div>
			<div class="columnText2" style="flex: 1;text-align: left;">
				前可免费取消
			</div>
		</div>
		<div v-for="(item, index) in datas.cancelPolicyList[3]" :key="index + 'cancelPolicyList3'">
			<div class="column" style="border-top: 1px dotted #E9E9E9;">
				<el-radio :disabled="disabled" v-model="datas.cancelType" v-show="index == 0" @click="handlerSelectClick(3)"
					:value="datas.cancelType == 3" :label="3">&nbsp;</el-radio>
				<div class="columnText2">
					入住前
				</div>
				<el-input :disabled="disabled" size="small" v-model="item.day" class="columnText3"
					placeholder-class="placeholder" style="width: 1rem;text-align: center;margin: 0 0.1rem;"
					placeholder="请输入" type="text"></el-input>
				<div class="columnText2" style="margin-right: 0.2rem;">
					天
				</div>
				<div class="columnText2" style="flex: 1;text-align: left;">
					前可免费取消
				</div>
				<el-input :disabled="disabled" size="small" class="columnText3" v-model="item.cancelProportion"
					placeholder-class="placeholder" style="width: 1rem;text-align: center;margin-right: 0.1rem;"
					placeholder="请输入" type="text"></el-input>
				<div class="columnText2" style="margin-right: 12rpx;">
					%
				</div>
			</div>
		</div>
		<div v-for="(item, index) in datas.cancelPolicyList[4]" :key="index + 'cancelPolicyList4'">
			<div class="column" style="border-top: 1px dotted #E9E9E9;">
				<el-radio v-model="datas.cancelType" :disabled="disabled" @click="handlerSelectClick(4)"
					:value="datas.cancelType == 4" :label="4">&nbsp;</el-radio>
				<div class="columnText3" style="width: 1rem;text-align: left;">{{ item.cancelData ?
					dateFormat(item.cancelData) : '请选择' }} </div>
				<div class="columnText2">
					日
				</div>
				<div style="margin: 0 0.1rem;width: 0.62rem;" class="columnText3">{{ item.cancelTime ? item.cancelTime :
					'请选择' }}</div>
				<div class="columnText2" style="flex: 1;text-align: left;">
					前可免费取消
				</div>
				<el-input :disabled="disabled" size="small" v-model="item.cancelProportion" class="columnText3"
					placeholder-class="placeholder" style="width: 1rem;text-align: center;margin-right: 0.1rem;"
					placeholder="请输入" type="text"></el-input>
				<div class="columnText2" style="margin-right: 12rpx;">
					%
				</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText4" style="margin-right: 0.1rem;">
				退改说明文字描述
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.cancelExplain" class="columnText3"
				placeholder-class="placeholder" style="flex: 1; " placeholder="请输入退改说明文字描述"
				type="text"></el-input>
		</div>
	</div>
</template>

<script>
import { dateFormat } from '@/assets/utils/unit'
export default {
	props: {
		datas: {
			type: Object,
			default: {}
		},
		disabled: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			dateFormat,
		}
	},
	methods: {
		handlerSelectClick(type) {
			this.$set(this.datas, 'cancelType', type)
		},
		//picker选择框
		handlerPickerClick(val, item, code) {
			if (code === 'cancelData') {
				this.$set(item, code, Date.parse(val.detail.value))
			} else {
				this.$set(item, code, val.detail.value)
			}
		},
		//新增
		handlerAddCancel(type) {
			let obj = {
				"cancelData": "",
				"cancelProportion": null,
				"cancelTime": "",
				"day": null,
				"id": null,
				"stockId": null
			}
			this.datas.cancelPolicyList[type].push(obj)
		},
		//删除设施
		handlerDeleteCancel(type, index) {
			let that = this
			uni.showModal({
				title: '提示',
				content: '您确定要删除吗？',
				success: function (res) {
					if (res.confirm) {
						that.$delete(that.datas.cancelPolicyList[type], index)
						uni.showToast({
							title: '删除成功',
							icon: 'none',
							duration: 1000
						});
					} else if (res.cancel) {
						console.log('用户点击取消');
					}
				}
			});
		},

	},
	watch: {
		datas: {
			handler(n, o) {
				this.$emit('updateDatas', n)
			},
			deep: true
		}
	}
}
</script>
<style lang="scss" scoped>
.ticketBox {
	border-radius: 0.05rem;
	background-color: rgba(250, 250, 250, 1);
	padding: 0 0.1rem;

	.column {
		height: 0.4rem;
		border-top: 1px dotted #E9E9E9;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&:nth-child(1) {
			border-top: none;
			height: 70rpx;
		}

		.columnText2 {
			color: rgba(149, 144, 144, 1);
			text-align: center;
		}

		.columnText3 {
			color: #000000;
			text-align: center;
		}

		.columnText4 {
			color: rgba(230, 74, 25, 1);
			text-align: center;
		}

		.columnText1 {
			color: #000000;
			font-size: 0.15rem;
			text-align: center;
		}
	}
}</style>
